// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"a87d9b2c","414":"bf895509"}[chunkId] + ".chunk.js";
};